import {Brick, registerBrick} from 'olympe';

/**
 * Convert a Map object into a String.
 */
export default class MapToString extends Brick {
    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {Map} map
     * @param {function(string)} setString
     */
    update($, [map], [setString]) {
        setString(JSON.stringify(map, (key, value) => (value instanceof Map ? [...value] : value)));
    }
}

registerBrick('018e7653f6ce579a0c77', MapToString);
